export const actionTypes = {
  FAILED: 'merchant-not-onboarding/failed',
  LOADING: 'merchant-not-onboarding/loading',
  SUCCESS: 'merchant-not-onboarding/success',
  FILTER: 'merchant-not-onboarding/filter',
  MESSAGE: 'merchant-not-onboarding/message',
  FORM: 'merchant-not-onboarding/form',
};

